import ENV from "react-dotenv";


import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";


import {
    LOG_USER_IN, LOG_USER_OUT, AUTHENTICATION_ACTION_TYPE,
    AUTHENTICATION_STATE_TYPE
} from "@Actions/Authentication";



const {APP_NAME} = ENV || {};
const APP_LOGGED_USER_KEY = (APP_NAME || "") + "_APP_LOGGED_USER";


const storedLoggedUser: string | null = localStorage.getItem(APP_LOGGED_USER_KEY);
const storedLoggedUserObject: LOGGED_USER_INTERFACE = !!storedLoggedUser ? JSON.parse(storedLoggedUser) : null;


const AuthenticationInitialState: AUTHENTICATION_STATE_TYPE = {
    loggedUser: storedLoggedUserObject
};


export const AuthenticationReducer = (
    state = AuthenticationInitialState,
    action: AUTHENTICATION_ACTION_TYPE
) => {

    switch (action.type) {

        case LOG_USER_IN:
            localStorage.setItem(APP_LOGGED_USER_KEY, JSON.stringify(action.user));
            return {...state, loggedUser: action.user};

        case LOG_USER_OUT:
            localStorage.removeItem(APP_LOGGED_USER_KEY);
            return {...state, loggedUser: null};

        default:
            return state;

    }

};


export default AuthenticationReducer;
